import TrinityTrigger from './trinity-trigger';

export default function(element, data, sendTrinityEvent) {
    element.addEventListener('mousedown', () => {
        if (TrinityTrigger.shouldTriggerTrinity(element)) {
            sendTrinityEvent(data);
        }
    });
}